export default {
  INITIAL: 'initial',
  REQUEST: 'request',
  SUCCESS: 'success',
  FAILURE: 'failure',
}



// WEBPACK FOOTER //
// ./src/components/Canvas/renderer/redux/utils/fetchStatus.js